module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h11"
  }, [_vm._v("Chapter 3")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "t15"
  }, [_vm._v("REMBLING")]), _vm._v(" "), _c('span', {
    staticClass: "t15"
  }, [_vm._v("OVERTAKES")]), _vm._v(" me as the gigantic sign comes into view:")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("THE CHURCH of SHELTON ROAD")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I steer the car into the parking lot and park near the huge sign. This will be the first church I’ve been in since…. No. I will not let those nightmares start. No spiders. Not tonight.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I shake my head to clear it. A long, cleansing breath of early evening air.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I can do this. It’s just a building, a performance space.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("The Church of Shelton Road is one of those “mega churches” that are all over TV. You can’t miss them, channel surfing on Sunday morning. Melissa said they have five thousand members. The complex is gigantic, with three enormous buildings set among a forest of oak trees and a parking lot that can hold thousands of cars. Melissa’s directions were clear: go in the door exactly opposite the sign, and that would put me in the choir practice room.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("As I step into the building, Melissa runs up. She must have been lying in wait.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“I see you found us,” she says, stunning in a red dress that shows off her hair. She’s beaming a huge, sparkling smile. If I weren’t so anxious here and if this weren’t a church, of all places, I could easily grab her and plant a big one on her lips. But as I calm myself and regain proper decorum, the doubts about Melissa return. Is she glad to see me, anxious to show off our talents, or wanting to display her boy-catching prowess? Could be any or all. I hate that she can turn me on and turn me off, all in a thirty-second cycle.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I cast my eyes at the floor and say, “Yeah.” Why am I here? Church is just not my thing.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Come on.” She grabs my hand. Possessive. “I want you to meet Brother Kenny, our Minister of Music.” I remember her "), _c('span', {
    staticClass: "t7"
  }, [_vm._v("husband")]), _vm._v(" joke, and pull away from her grasp.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("She looks at me with a "), _c('span', {
    staticClass: "t7"
  }, [_vm._v("whatever")]), _vm._v(" look, but my maneuver doesn’t stop her. She latches onto my arm, dragging me across the room to a sandy-haired man.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("He sports a perfectly tailored suit, and his hair is shaped and styled. This guy is raking in the big bucks at this place.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Kenny,” Melissa says, “I want you to meet Neil Darrien.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("The music minister clasps my right hand and shakes it vigorously, holding on for dear life. “Welcome to the Church, Neil.” His smile slashes his face. Friendly. A bit smarmy. “Your tape blew me away. And Melissa’s told me great things about you. We’re glad you have chosen to worship with us.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Uh-oh. A tiny knot begins to form in my stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Just here to sing, sir,” I say, trying not to emphasize "), _c('span', {
    staticClass: "t7"
  }, [_vm._v("sing")]), _vm._v(" too much. I don’t want to make the guy mad. After all, a chance to perform is a chance to perform. But I don’t want to feed any soul-saving designs he may have, either.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“And”—Kenny glances at the clock on the back wall—“it’s almost time for just that. Excuse me a moment. I need some quiet time with the Lord before we begin.” He retreats into an office off the rehearsal room.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Come on, Neil,” Melissa says, grabbing my arm once more, “we’ll sit here.” She’s being particularly bossy tonight. I hope it’s just her way of trying to make me feel welcome.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("She yanks me to a couple of very comfortable-looking, padded folding chairs in the center of the front row.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Worship?” I whisper, leaning close to Melissa.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Don’t mind Brother Kenny. That’s just the way he talks.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I need several deep breaths. Let’s get this thing started. "), _c('span', {
    staticClass: "t7"
  }, [_vm._v("Help me, Satine.")]), _vm._v(" Melissa bows her head, praying. Seeing this, I require several more deep breaths. This time I don’t invoke the powers of Satine. I really need to stop doing that.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("When the room fills up, Brother Kenny emerges from the office and steps in front of the group.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I survey the room. There must be 150 voices in this choir.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t16"
  }, [_vm._v("“Praise the Lord,” Brother Kenny intones. A chorus of amens. “Isn’t this a beautiful evening to raise our voices to our Savior?” More amens.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t26"
  }, [_vm._v("What have I gotten myself into?")]), _vm._v(" "), _c('span', {
    staticClass: "t18"
  }, [_vm._v("Melissa shoots me a")]), _vm._v(" "), _c('span', {
    staticClass: "t26"
  }, [_vm._v("don’t worry")]), _vm._v(" "), _c('span', {
    staticClass: "t18"
  }, [_vm._v("look.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“We are blessed tonight,” Brother Kenny continues, “to have a new sheep in our fold. Melissa has brought her friend Neil to us. Stand up, Neil.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("No doubt red as a fire truck, I stand and turn to the group, nod, then sit down.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Neil has a mighty instrument, and he is here to share it with us and the Lord tonight, and, of course, at our Sunday morning service.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("The group applauds as a few of them shout “Praise God” and “Welcome, Brother Neil.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Just concentrate on the singing. This will be your biggest audience ever. Forget about all this Jesus stuff and focus on your craft.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Let’s begin our practice with a prayer, shall we?” Brother Kenny bows his head. “Lord, we come to you in thanksgiving this evening for bringing Neil to us. We ask you bless us as we prepare the music for Sunday’s services and that you particularly bless Melissa and Neil as they share their talents with you, Lord. To Thine be the Glory. In Jesus’s precious, Holy Name. Amen.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Again, several choir members echo amen. Cringe.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Brother Kenny takes the choir through a series of warm-ups not unlike the warm-ups Ms. Walter puts us through at school.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("After that, Kenny announces, “Let’s begin with a few of the pieces we’re putting on our CD.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("The accompanist begins at Kenny’s signal, and the others immediately recognize each piece. Melissa scrambles to find the sheet music in the folder for me to use. I’m still stuck on "), _c('span', {
    staticClass: "t7"
  }, [_vm._v("CD")]), _vm._v(". Amazing. They’re making a CD? "), _c('span', {
    staticClass: "t7"
  }, [_vm._v("Wow")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t16"
  }, [_vm._v("After about twenty minutes, Kenny says, “Glorious. What praise. We’re going to be awesome when they come in to tape our performances.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“No tape, Brother; it’s all digital these days,” someone in the back shouts, ignoring Kenny’s nod to adolescence, "), _c('span', {
    staticClass: "t7"
  }, [_vm._v("awesome,")]), _vm._v(" and latching onto the second half of his remark. The entire group breaks up at Brother Kenny’s bewildered look.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Don’t plague me with the details, brothers and sisters, just sing as heavenly the day of the recording, no matter how the miracle is accomplished. Now, look in your folders for a new piece, ‘How Lovely Are the Dwellings.’ We want this to be letter perfect on Sunday morning so Melissa and Neil’s solos will shine and be an offering for the Lord.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("We spend the next twenty minutes going over the choral parts of the piece. These people are fantastic. They pick up the parts instantly, sight-reading like pros. This is a top-notch group. I begin to relax as my attention flows more and more into the music.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Great,” Brother Kenny peals. “"), _c('span', {
    staticClass: "t7"
  }, [_vm._v("Wondrous")]), _vm._v(" praise"), _c('span', {
    staticClass: "t7"
  }, [_vm._v(".")]), _vm._v("” He turns to Melissa and me. “Ready to add your solos?”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("We nod and stand.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Brother Kenny’s hands beat a classic four/four rhythm and then he gestures; the pianist begins the magical intro. The familiar melody fills the room. Melissa waits for her cue, and at Brother Kenny’s sign, her bell-like soprano soars with the first phrase. Brother Kenny looks at me, nods, and the countermelody swims from my throat. As we weave the two melodies together, Brother Kenny brings in the choir, with their lovely contrapuntal harmonies. The flood of glorious music swells and recedes until Brother Kenny conducts all the singers to a close, almost a whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I am awestruck. "), _c('span', {
    staticClass: "t7"
  }, [_vm._v("What a rush.")]), _vm._v(" "), _c('span', {
    staticClass: "t7"
  }, [_vm._v("The school’s choir does a great job with this piece, but this group puts us to shame. This is what performing is all about.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Brother Kenny has a huge grin on his face. “And the Lord said, ‘Make a joyful noise.’ Surely, he is smiling in his heavens tonight. Thank you for lifting your voices in praise. Can I get an ‘amen’ for Melissa and Neil?”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("And again “Amen!” tolls loudly through the room.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Ready for a surprise?”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("The choir looks at the Cheshire-cat smile on Brother Kenny’s face and roars, “You bet,” in unison.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("My eyes widen. Obviously, this is a common occurrence for this group. They’ve got their reaction down to a science.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t16"
  }, [_vm._v("“Well, fellow Christians,” Brother Kenny says, like a kid in a candy store, “I just knew this was going to be a moment of splendor for this group, so I’ve asked the church orchestra to join us. Steve,” he points to the man sitting next to me, “would you go fetch them, please?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("The man leaps up and lopes from the room.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t16"
  }, [_vm._v("“Okay, choir, take ten while the orchestra sets up,” Brother Kenny orders. “Could some of you guys help carry in chairs and stands?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I don’t know what to do as most of the men follow Kenny from the room. Do I help or do I stay and play first-timer rookie?")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("The choir members left in the room stand, stretch, and visit.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Melissa turns to me. “You won’t believe your ears, Neil. This is awesome.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Orchestra members file in, carrying their violins, cellos, basses, horns, clarinets, etc. The men of the choir follow with stands and chairs. In a flurry, the room is ready.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Okay, gang,” Brother Kenny bellows over the cacophony of the instruments tuning, “take your seats.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("The choir reassembles.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Let’s do a run-through,” Brother Kenny commands, raising his arms, one hand now holding a baton.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("The choir rises, and Kenny gives the downbeat.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Glorious music engulfs me. My soul expands as the strings play the intro to the piece. That’s the only way I know to describe what I’m feeling. Kenny gives the signal for the tenors to come in. It’s like the heavens open and angels descend. My heart may burst with all this glory. When my solo comes up, I am so filled with joy it takes no effort whatsoever. It’s like the song is singing itself. I tremble as the piece ends. This is what rapture is truly like.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Amazing,” Brother Kenny says. “The Lord has "), _c('span', {
    staticClass: "t7"
  }, [_vm._v("spoken")]), _vm._v(". I don’t know how it could get any better.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Amen!” everyone in the room cries in unison.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“But just to make sure….”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("They all laugh at Brother Kenny. Both the singers and the musicians know there was no way he would let them perform on Sunday morning without doing it at least a couple more times… which we do. And each time fills me just as much as the first.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("The magic ends, Brother Kenny announces, “See you Sunday morning, brothers and sisters.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Several choir members stop me before I can leave, shaking my hand and welcoming me to the group. Some of them even hug me as they shout more praises. I’m almost so bowled over I’m not bothered by all this. Almost. Their hospitality makes me feel good. But those hands. Clutching. Surrounding.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Shake it off, Neil.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("So I smile and thank them. But this is still a church, and I want out of here, away from their pawing, no matter how good their intentions might be. I feel the crawling spiders. Memories are pushing through, memories I don’t want to have, don’t want to feel.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t16"
  }, [_vm._v("Finally, I make it to the door, Melissa trailing me, the adoring mate.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("She walks me to my car.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“You were great, Neil,” she says, her arm linked in mine. I can’t pull away. She’s locked. We stop by my car door. I try to retreat. She entwines me in a surprise hug. “Thank you for doing this.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“You’re welcome,” I say, surrendering to her soft arms, something I rarely do. I can’t stand anybody touching me. But tonight, I guess I’m horny. I turn her around, lean her against the car door, and move in for a kiss.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("The kiss lingers. It feels good. Then she spoils it. Melissa pulls away, slips out from under my embrace, takes a step away, lets out a tiny laugh. “Don’t, Neil. Not here. What if someone told my mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t16"
  }, [_vm._v("Always the good little girl. Or at least that’s the image she—and her mother—want to portray. But those times in dark movie theaters? Those times in the swing hidden behind vines in her backyard?")]), _vm._v(" "), _c('span', {
    staticClass: "t17"
  }, [_vm._v("What about those times, Melissa? You didn’t pull away then.")]), _vm._v(" "), _c('span', {
    staticClass: "t16"
  }, [_vm._v("But she’s right. The last thing I need is to get on her mother’s bad side. Priorities straight, I turn to the experience we had just before the one that gave me a stiffy.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“It was a little intense in there for me. I’m not used to all those ‘amens’ and ‘praise the Lords.’” A tiny, nervous laugh escapes. I feel uneasy. And when the feeling overcomes me, all I want to do is flee. But I don’t want to hurt her feelings. So I’m trapped.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Stick around here, and you’ll "), _c('span', {
    staticClass: "t7"
  }, [_vm._v("get")]), _vm._v(" used to it.” Melissa grins, once again in her element: church. She’s no longer uneasy about the kiss, it seems. “They get a little carried away sometimes. Don’t get me wrong. I love the Lord, but I’m not much for all the shouting. But I do love the choir. Aren’t they incredible?”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“You’re right there. I’ve never heard such a group before, much less sung with one. And that orchestra—awesome.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Wasn’t that a surprise? Brother Kenny doesn’t bring in the orchestra very often. Wow.” She pauses. “Now, just to remind you, be here on Sunday morning at twenty till eleven. That will give us enough time to find you a choir robe. Kenny likes to warm-up the choir at ten of. After, we file into the sanctuary for the service.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("From the corner of my eye, I notice the stained glass windows of the church, lit from inside. A quiver.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“I thought we would have rehearsed in the church itself,” I say, gulping. “I feel a little uneasy not knowing what I will sound like in there.” Or how I’ll react in there.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“I knew that’s what you’d say. I asked Kenny to let us rehearse in the sanctuary, but there was a wedding rehearsal in there tonight, so we couldn’t. But don’t worry, it is a wonderful performance space. Perfect acoustics. You’ll love it.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "t15"
  }, [_vm._v("HE")]), _vm._v(" "), _c('span', {
    staticClass: "t15"
  }, [_vm._v("DRIVE")]), _vm._v(" home is an ordeal. Unwanted and unwelcome thoughts flood in and out of my consciousness like waves hitting the shore, then rolling back out to sea. It’s a wonder I don’t crash the car. I can’t concentrate on anything but negatives.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Can I really do this? "), _c('span', {
    staticClass: "t7"
  }, [_vm._v("It’s been nine years, Neil. You’re not the same person. You were just a little kid then. Now you’re almost grown. Performing is your life now, and the Church of Shelton Road is a great venue… fantastic choir and orchestra, a guaranteed huge audience. You can’t pass up this chance.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("A blinking red light halts me. I wait for cars ahead of me to make their moves. The red light blinks on, off, on, off. The colors.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Don’t, Brother Gramm. Please, leave me alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("But you know you like it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("The nine-year-old me feels Brother Gramm’s clammy arms envelop me in a tight hug.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("No! Please! You’re hurting me.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("A loud honk shocks me back to reality. The driver behind me is blaring his horn, trying to make me pull on through the intersection.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I give a wave, hoping to appease the guy. Then I accelerate.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("He’s hurting me, Mom.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Who?")]), _vm._v(" She sounds concerned.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Brother Gramm,")]), _vm._v(" I say. It is hard to tell her what he’s been doing. Everybody at church loves the pastor so much. I tell her"), _c('span', {
    staticClass: "t7"
  }, [_vm._v(": Mom, he hugs me and touches me. I don’t like it")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("She just looks at me and says"), _c('span', {
    staticClass: "t7"
  }, [_vm._v(", Nonsense, Neil. Brother Gramm just loves you. He’s a very loving man.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Why wouldn’t she believe me?")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Tears. "), _c('span', {
    staticClass: "t7"
  }, [_vm._v("Nine-year-old")]), _vm._v(" tears. They cloud my eyes so much I almost miss the turn onto our street.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Tears, go away.")]), _vm._v(" I swipe my eyes and will myself to stop crying.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("No, I’ve got to get a grip. I can’t let what Brother Gramm did ruin my life. The Church of Shelton Road is a fantastic opportunity for me.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("And as Satine said in the episode where they were auditioning for solos, “Never pass on a chance, Bucko. You never know if it will come again.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Perfect acoustics, didn’t Melissa say?")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "t15"
  }, [_vm._v("UNT")]), _vm._v(" "), _c('span', {
    staticClass: "t14"
  }, [_vm._v("J")]), _c('span', {
    staticClass: "t15"
  }, [_vm._v("ENNY")]), _vm._v(" is already in her studio, working away, when I awake on Sunday morning. Her jewelry pieces sell quickly at several gift shops around town, and she is able to make enough from the sales to keep us both in food and clothes. She is my godsend.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t16"
  }, [_vm._v("“You were up early,” she says as I pass by the door to the studio, which is just off the kitchen. “I heard your weights clanking at 5:00 a.m.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“I got up early to work out. Sorry.” She means well, but why does she hound me all the time?")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“You didn’t bother me,” she says. “You know me. I was in the studio way before dawn. I do my best stuff early in the morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“You do good work any time of the day.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Thank you, Mister,” she says. She’s pounding away on a piece of metal she’s sculpting into a bracelet. “But you overdo the weight lifting. Don’t you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("She’s staring at her work, but I know her concentration is entirely on me. Never underestimate the Power of Jenny.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“I have to keep in shape. You know that. You heard what Mona Tulle said about my body: ‘total control.’ I can’t lose that.” I go from the doorway to the refrigerator to pour a glass of orange juice.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Okay.” She sighs. I smile. The Weight Lifting Battle. Continual. The fight is never-ending. Okay, so she let me win the battle this time. But the war rages on.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Ready for your big church debut? I heard you vocalizing this morning too. Sounded great,” she calls out.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I take the OJ into the studio, where Aunt Jenny is busily soldering a clasp onto the bracelet.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Yeah.” I gulp the juice as I lean on the doorjamb. “It’ll be fun. The choir is great, Melissa’s voice is beautiful, as usual, and I really enjoyed singing with the orchestra accompaniment. The morning’s performance will go well, I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Stay focused, Neil. It’s just a performance. Like any other. Big audience. Great orchestra. Great choir. Forget it’s a church.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Do you know where you’ll be on the program?”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“We should be about fifteen minutes into the service, before the sermon.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t16"
  }, [_vm._v("“Great,” Aunt Jenny says. “I can sneak in the back, hear your song, slip out. You know me and church. I don’t rightly cotton to the hellfiah and brimstone fokes.” Aunt Jenny steps into her Deep South persona.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("She makes me laugh. “Yeah,” I say, “neither do I, but I’m trapped until the end. Lucky you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Honey chile,” she drawls, keeping up the Southern belle routine, “while you’re praisin’ the lawd, I’ll be here frying up some Sunday chicken, you heah?”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I give her the old roll of the eyes. “Give me a break—the magnolia and peach blossom routine doesn’t impress me. The only fried chicken you ever came up with costs $15.99 a bucket.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Aunt Jenny huffs, pretending she is offended. “For your information, sonny, they’ve raised the price. I swanee—a gal can hardly affoad t’ feed her man these days.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I kiss her on the cheek. “Gotta run.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "t15"
  }, [_vm._v("ELISSA")]), _vm._v(" "), _c('span', {
    staticClass: "t15"
  }, [_vm._v("AND")]), _vm._v(" I grab our positions in the choir just as Brother Kenny is saying, “Let us pray.”")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I sigh and bow my head. Singing is what I’m here to do, not pray. Melissa takes my hand as we pray. It helps.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Warm-ups go by in a flash, and then Brother Kenny leads us through a short hallway. The orchestra is already in place as the choir files into the sanctuary.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I audibly gasp, then check myself. "), _c('span', {
    staticClass: "t7"
  }, [_vm._v("Control yourself, Neil.")]), _vm._v(" The place is enormous. It’s as big as any football stadium I’ve ever seen. Masses of people sit in purple, velvet-upholstered, theater-style seats. The assistant pastors are enthroned in the only pews in the church, ornately carved ones sitting on either side of the pulpit. The carpet down the center aisle matches the seats, with a swirl of gold running through the purple background.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t16"
  }, [_vm._v("I’ve never, ever performed in such a huge space before. As we file into the choir loft, I say my own little prayer: “Give me strength.” To whom, I don’t know. Maybe God, maybe the cosmos, maybe Satine. I just know I always speak to an inner spirit before a performance.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Brother Kenny gives the signal for us to sit. As one of the assistant pastors stands to begin the service, I check out the room. There are literally thousands of people, dressed in all manners. Some of the women are decked out in fancy dresses with hats, while others are in pantsuits. Many of the men have on suits, while others are just in shirts and ties, and still others in plain golf shirts. It’s definitely a mix of humanity.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Some place. This church is nothing more than a big theater. A lot of money flows through these doors.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I’m distracting myself. I can’t think about where I really am.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("After an assistant pastor welcomes the congregants and makes a few announcements, he asks us all to stand for the opening prayer. All us choir robe-clad singers stand, along with the congregation. I bow my head. But I refuse to pray.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Then I see them.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Red. Green. Blue. Yellow. Purple. Orange.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t16"
  }, [_vm._v("The colors swirl, landing on the white choir robe I’m wearing. I feel my pulse quicken. I look to my right. Colors dapple Melissa’s robe as well. A drop of sweat forms on my brow. Where are they coming from?")]), _vm._v(" "), _c('span', {
    staticClass: "t16"
  }, [_vm._v("Panic starts")]), _c('span', {
    staticClass: "t17"
  }, [_vm._v(". Ignore them… ignore them, ignore them, ignore them.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Orange. Red. Blue….")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t16"
  }, [_vm._v("Not a word of the prayer registers. Colors bathe all of the previously snow-white choir robes. I feel shaky.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Green…. Purple…. Yellow.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("The stained glass windows are too far away. They couldn’t possibly be the cause of my panic. Yes, colors spill over the congregation, but they don’t bother me. It’s the colors on me pulling me back, back to that horrible long ago.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Where? Where?")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I look up. In the nave of the sanctuary, above the choir loft, are two huge stained glass skylights.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Sweat pours off my cheeks. I feel light-headed.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Stay standing, Neil. Don’t embarrass yourself in front of all these people.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("But my knees buckle. I fall back, into my seat, brushing Melissa along the way.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Startled, she turns.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“What’s wrong, Neil?” she whispers.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("“Nothing,” I say, feeling my heartbeat racing. “I’ll be okay. Just a little stage fright.” Please, oh please, let her believe my lie.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("She smiles at me, then bows her head again.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I need to get out of here. I cover my eyes with the palm of my hand. This is making me crazy. Deep breaths"), _c('span', {
    staticClass: "t7"
  }, [_vm._v(". Come on, Neil.")]), _vm._v(" But my breaths are shallow, too shallow to do any good. I open my eyes and try to stand. I can’t leave. I have a song to sing. I blink a few times to stop my head from swimming.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("No, it doesn’t matter. I’ve got to get out of here!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49400080","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/011.vue
// module id = 84
// module chunks = 0